/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SplatRouteImport } from './routes/$'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as ProdutosNaoVinculadosIndexRouteImport } from './routes/produtos-nao-vinculados/index'
import { Route as AuthenticatedAtualizarTransacoesIndexRouteImport } from './routes/_authenticated/atualizar-transacoes/index'
import { Route as AuthenticatedCadastrosCodigoMapaIndexRouteImport } from './routes/_authenticated/cadastros-codigo-mapa/index'
import { Route as AuthenticatedConversaoUnidadeMedidaIndexRouteImport } from './routes/_authenticated/conversao-unidade-medida/index'
import { Route as AuthenticatedDashboardIndexRouteImport } from './routes/_authenticated/dashboard/index'
import { Route as AuthenticatedEstabelecimentosIndexRouteImport } from './routes/_authenticated/estabelecimentos/index'
import { Route as AuthenticatedHistoricoPublicacaoIndexRouteImport } from './routes/_authenticated/historico-publicacao/index'
import { Route as AuthenticatedImportacaoIndexRouteImport } from './routes/_authenticated/importacao/index'
import { Route as AuthenticatedRelatorioTransacoesIndexRouteImport } from './routes/_authenticated/relatorio-transacoes/index'
import { Route as AuthenticatedUnidadesIndexRouteImport } from './routes/_authenticated/unidades/index'
import { Route as AuthenticatedUsuariosIndexRouteImport } from './routes/_authenticated/usuarios/index'
import { Route as AuthenticatedVinculosMapaIndexRouteImport } from './routes/_authenticated/vinculos-mapa/index'
import { Route as AuthenticatedAdminEmpresasIndexRouteImport } from './routes/_authenticated/admin/empresas/index'
import { Route as AuthenticatedAdminEstabelecimentosIndexRouteImport } from './routes/_authenticated/admin/estabelecimentos/index'
import { Route as AuthenticatedAdminSincronizacaoPgaIndexRouteImport } from './routes/_authenticated/admin/sincronizacao-pga/index'
import { Route as AuthenticatedAdminUnidadesIndexRouteImport } from './routes/_authenticated/admin/unidades/index'
import { Route as AuthenticatedAdminUsuariosIndexRouteImport } from './routes/_authenticated/admin/usuarios/index'
import { Route as AuthenticatedRelatorioTransacoesTipoAnoIndexRouteImport } from './routes/_authenticated/relatorio-transacoes/$tipo/$ano/index'
import { Route as AuthenticatedRelatorioTransacoesTipoAnoMesRouteImport } from './routes/_authenticated/relatorio-transacoes/$tipo/$ano/$mes'

const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProdutosNaoVinculadosIndexRoute =
  ProdutosNaoVinculadosIndexRouteImport.update({
    id: '/produtos-nao-vinculados/',
    path: '/produtos-nao-vinculados/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthenticatedAtualizarTransacoesIndexRoute =
  AuthenticatedAtualizarTransacoesIndexRouteImport.update({
    id: '/atualizar-transacoes/',
    path: '/atualizar-transacoes/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCadastrosCodigoMapaIndexRoute =
  AuthenticatedCadastrosCodigoMapaIndexRouteImport.update({
    id: '/cadastros-codigo-mapa/',
    path: '/cadastros-codigo-mapa/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedConversaoUnidadeMedidaIndexRoute =
  AuthenticatedConversaoUnidadeMedidaIndexRouteImport.update({
    id: '/conversao-unidade-medida/',
    path: '/conversao-unidade-medida/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDashboardIndexRoute =
  AuthenticatedDashboardIndexRouteImport.update({
    id: '/dashboard/',
    path: '/dashboard/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEstabelecimentosIndexRoute =
  AuthenticatedEstabelecimentosIndexRouteImport.update({
    id: '/estabelecimentos/',
    path: '/estabelecimentos/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHistoricoPublicacaoIndexRoute =
  AuthenticatedHistoricoPublicacaoIndexRouteImport.update({
    id: '/historico-publicacao/',
    path: '/historico-publicacao/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedImportacaoIndexRoute =
  AuthenticatedImportacaoIndexRouteImport.update({
    id: '/importacao/',
    path: '/importacao/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRelatorioTransacoesIndexRoute =
  AuthenticatedRelatorioTransacoesIndexRouteImport.update({
    id: '/relatorio-transacoes/',
    path: '/relatorio-transacoes/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUnidadesIndexRoute =
  AuthenticatedUnidadesIndexRouteImport.update({
    id: '/unidades/',
    path: '/unidades/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUsuariosIndexRoute =
  AuthenticatedUsuariosIndexRouteImport.update({
    id: '/usuarios/',
    path: '/usuarios/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedVinculosMapaIndexRoute =
  AuthenticatedVinculosMapaIndexRouteImport.update({
    id: '/vinculos-mapa/',
    path: '/vinculos-mapa/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminEmpresasIndexRoute =
  AuthenticatedAdminEmpresasIndexRouteImport.update({
    id: '/admin/empresas/',
    path: '/admin/empresas/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminEstabelecimentosIndexRoute =
  AuthenticatedAdminEstabelecimentosIndexRouteImport.update({
    id: '/admin/estabelecimentos/',
    path: '/admin/estabelecimentos/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminSincronizacaoPgaIndexRoute =
  AuthenticatedAdminSincronizacaoPgaIndexRouteImport.update({
    id: '/admin/sincronizacao-pga/',
    path: '/admin/sincronizacao-pga/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminUnidadesIndexRoute =
  AuthenticatedAdminUnidadesIndexRouteImport.update({
    id: '/admin/unidades/',
    path: '/admin/unidades/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminUsuariosIndexRoute =
  AuthenticatedAdminUsuariosIndexRouteImport.update({
    id: '/admin/usuarios/',
    path: '/admin/usuarios/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRelatorioTransacoesTipoAnoIndexRoute =
  AuthenticatedRelatorioTransacoesTipoAnoIndexRouteImport.update({
    id: '/relatorio-transacoes/$tipo/$ano/',
    path: '/relatorio-transacoes/$tipo/$ano/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRelatorioTransacoesTipoAnoMesRoute =
  AuthenticatedRelatorioTransacoesTipoAnoMesRouteImport.update({
    id: '/relatorio-transacoes/$tipo/$ano/$mes',
    path: '/relatorio-transacoes/$tipo/$ano/$mes',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/$': typeof SplatRoute
  '/': typeof AuthenticatedIndexRoute
  '/login/': typeof LoginIndexRoute
  '/produtos-nao-vinculados/': typeof ProdutosNaoVinculadosIndexRoute
  '/atualizar-transacoes/': typeof AuthenticatedAtualizarTransacoesIndexRoute
  '/cadastros-codigo-mapa/': typeof AuthenticatedCadastrosCodigoMapaIndexRoute
  '/conversao-unidade-medida/': typeof AuthenticatedConversaoUnidadeMedidaIndexRoute
  '/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/estabelecimentos/': typeof AuthenticatedEstabelecimentosIndexRoute
  '/historico-publicacao/': typeof AuthenticatedHistoricoPublicacaoIndexRoute
  '/importacao/': typeof AuthenticatedImportacaoIndexRoute
  '/relatorio-transacoes/': typeof AuthenticatedRelatorioTransacoesIndexRoute
  '/unidades/': typeof AuthenticatedUnidadesIndexRoute
  '/usuarios/': typeof AuthenticatedUsuariosIndexRoute
  '/vinculos-mapa/': typeof AuthenticatedVinculosMapaIndexRoute
  '/admin/empresas/': typeof AuthenticatedAdminEmpresasIndexRoute
  '/admin/estabelecimentos/': typeof AuthenticatedAdminEstabelecimentosIndexRoute
  '/admin/sincronizacao-pga/': typeof AuthenticatedAdminSincronizacaoPgaIndexRoute
  '/admin/unidades/': typeof AuthenticatedAdminUnidadesIndexRoute
  '/admin/usuarios/': typeof AuthenticatedAdminUsuariosIndexRoute
  '/relatorio-transacoes/$tipo/$ano/$mes': typeof AuthenticatedRelatorioTransacoesTipoAnoMesRoute
  '/relatorio-transacoes/$tipo/$ano/': typeof AuthenticatedRelatorioTransacoesTipoAnoIndexRoute
}
export interface FileRoutesByTo {
  '/$': typeof SplatRoute
  '/': typeof AuthenticatedIndexRoute
  '/login': typeof LoginIndexRoute
  '/produtos-nao-vinculados': typeof ProdutosNaoVinculadosIndexRoute
  '/atualizar-transacoes': typeof AuthenticatedAtualizarTransacoesIndexRoute
  '/cadastros-codigo-mapa': typeof AuthenticatedCadastrosCodigoMapaIndexRoute
  '/conversao-unidade-medida': typeof AuthenticatedConversaoUnidadeMedidaIndexRoute
  '/dashboard': typeof AuthenticatedDashboardIndexRoute
  '/estabelecimentos': typeof AuthenticatedEstabelecimentosIndexRoute
  '/historico-publicacao': typeof AuthenticatedHistoricoPublicacaoIndexRoute
  '/importacao': typeof AuthenticatedImportacaoIndexRoute
  '/relatorio-transacoes': typeof AuthenticatedRelatorioTransacoesIndexRoute
  '/unidades': typeof AuthenticatedUnidadesIndexRoute
  '/usuarios': typeof AuthenticatedUsuariosIndexRoute
  '/vinculos-mapa': typeof AuthenticatedVinculosMapaIndexRoute
  '/admin/empresas': typeof AuthenticatedAdminEmpresasIndexRoute
  '/admin/estabelecimentos': typeof AuthenticatedAdminEstabelecimentosIndexRoute
  '/admin/sincronizacao-pga': typeof AuthenticatedAdminSincronizacaoPgaIndexRoute
  '/admin/unidades': typeof AuthenticatedAdminUnidadesIndexRoute
  '/admin/usuarios': typeof AuthenticatedAdminUsuariosIndexRoute
  '/relatorio-transacoes/$tipo/$ano/$mes': typeof AuthenticatedRelatorioTransacoesTipoAnoMesRoute
  '/relatorio-transacoes/$tipo/$ano': typeof AuthenticatedRelatorioTransacoesTipoAnoIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/$': typeof SplatRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/login/': typeof LoginIndexRoute
  '/produtos-nao-vinculados/': typeof ProdutosNaoVinculadosIndexRoute
  '/_authenticated/atualizar-transacoes/': typeof AuthenticatedAtualizarTransacoesIndexRoute
  '/_authenticated/cadastros-codigo-mapa/': typeof AuthenticatedCadastrosCodigoMapaIndexRoute
  '/_authenticated/conversao-unidade-medida/': typeof AuthenticatedConversaoUnidadeMedidaIndexRoute
  '/_authenticated/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/_authenticated/estabelecimentos/': typeof AuthenticatedEstabelecimentosIndexRoute
  '/_authenticated/historico-publicacao/': typeof AuthenticatedHistoricoPublicacaoIndexRoute
  '/_authenticated/importacao/': typeof AuthenticatedImportacaoIndexRoute
  '/_authenticated/relatorio-transacoes/': typeof AuthenticatedRelatorioTransacoesIndexRoute
  '/_authenticated/unidades/': typeof AuthenticatedUnidadesIndexRoute
  '/_authenticated/usuarios/': typeof AuthenticatedUsuariosIndexRoute
  '/_authenticated/vinculos-mapa/': typeof AuthenticatedVinculosMapaIndexRoute
  '/_authenticated/admin/empresas/': typeof AuthenticatedAdminEmpresasIndexRoute
  '/_authenticated/admin/estabelecimentos/': typeof AuthenticatedAdminEstabelecimentosIndexRoute
  '/_authenticated/admin/sincronizacao-pga/': typeof AuthenticatedAdminSincronizacaoPgaIndexRoute
  '/_authenticated/admin/unidades/': typeof AuthenticatedAdminUnidadesIndexRoute
  '/_authenticated/admin/usuarios/': typeof AuthenticatedAdminUsuariosIndexRoute
  '/_authenticated/relatorio-transacoes/$tipo/$ano/$mes': typeof AuthenticatedRelatorioTransacoesTipoAnoMesRoute
  '/_authenticated/relatorio-transacoes/$tipo/$ano/': typeof AuthenticatedRelatorioTransacoesTipoAnoIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/$'
    | '/'
    | '/login/'
    | '/produtos-nao-vinculados/'
    | '/atualizar-transacoes/'
    | '/cadastros-codigo-mapa/'
    | '/conversao-unidade-medida/'
    | '/dashboard/'
    | '/estabelecimentos/'
    | '/historico-publicacao/'
    | '/importacao/'
    | '/relatorio-transacoes/'
    | '/unidades/'
    | '/usuarios/'
    | '/vinculos-mapa/'
    | '/admin/empresas/'
    | '/admin/estabelecimentos/'
    | '/admin/sincronizacao-pga/'
    | '/admin/unidades/'
    | '/admin/usuarios/'
    | '/relatorio-transacoes/$tipo/$ano/$mes'
    | '/relatorio-transacoes/$tipo/$ano/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/$'
    | '/'
    | '/login'
    | '/produtos-nao-vinculados'
    | '/atualizar-transacoes'
    | '/cadastros-codigo-mapa'
    | '/conversao-unidade-medida'
    | '/dashboard'
    | '/estabelecimentos'
    | '/historico-publicacao'
    | '/importacao'
    | '/relatorio-transacoes'
    | '/unidades'
    | '/usuarios'
    | '/vinculos-mapa'
    | '/admin/empresas'
    | '/admin/estabelecimentos'
    | '/admin/sincronizacao-pga'
    | '/admin/unidades'
    | '/admin/usuarios'
    | '/relatorio-transacoes/$tipo/$ano/$mes'
    | '/relatorio-transacoes/$tipo/$ano'
  id:
    | '__root__'
    | '/$'
    | '/_authenticated'
    | '/_authenticated/'
    | '/login/'
    | '/produtos-nao-vinculados/'
    | '/_authenticated/atualizar-transacoes/'
    | '/_authenticated/cadastros-codigo-mapa/'
    | '/_authenticated/conversao-unidade-medida/'
    | '/_authenticated/dashboard/'
    | '/_authenticated/estabelecimentos/'
    | '/_authenticated/historico-publicacao/'
    | '/_authenticated/importacao/'
    | '/_authenticated/relatorio-transacoes/'
    | '/_authenticated/unidades/'
    | '/_authenticated/usuarios/'
    | '/_authenticated/vinculos-mapa/'
    | '/_authenticated/admin/empresas/'
    | '/_authenticated/admin/estabelecimentos/'
    | '/_authenticated/admin/sincronizacao-pga/'
    | '/_authenticated/admin/unidades/'
    | '/_authenticated/admin/usuarios/'
    | '/_authenticated/relatorio-transacoes/$tipo/$ano/$mes'
    | '/_authenticated/relatorio-transacoes/$tipo/$ano/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  SplatRoute: typeof SplatRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginIndexRoute: typeof LoginIndexRoute
  ProdutosNaoVinculadosIndexRoute: typeof ProdutosNaoVinculadosIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/produtos-nao-vinculados/': {
      id: '/produtos-nao-vinculados/'
      path: '/produtos-nao-vinculados'
      fullPath: '/produtos-nao-vinculados/'
      preLoaderRoute: typeof ProdutosNaoVinculadosIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/atualizar-transacoes/': {
      id: '/_authenticated/atualizar-transacoes/'
      path: '/atualizar-transacoes'
      fullPath: '/atualizar-transacoes/'
      preLoaderRoute: typeof AuthenticatedAtualizarTransacoesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/cadastros-codigo-mapa/': {
      id: '/_authenticated/cadastros-codigo-mapa/'
      path: '/cadastros-codigo-mapa'
      fullPath: '/cadastros-codigo-mapa/'
      preLoaderRoute: typeof AuthenticatedCadastrosCodigoMapaIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/conversao-unidade-medida/': {
      id: '/_authenticated/conversao-unidade-medida/'
      path: '/conversao-unidade-medida'
      fullPath: '/conversao-unidade-medida/'
      preLoaderRoute: typeof AuthenticatedConversaoUnidadeMedidaIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard/': {
      id: '/_authenticated/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AuthenticatedDashboardIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/estabelecimentos/': {
      id: '/_authenticated/estabelecimentos/'
      path: '/estabelecimentos'
      fullPath: '/estabelecimentos/'
      preLoaderRoute: typeof AuthenticatedEstabelecimentosIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/historico-publicacao/': {
      id: '/_authenticated/historico-publicacao/'
      path: '/historico-publicacao'
      fullPath: '/historico-publicacao/'
      preLoaderRoute: typeof AuthenticatedHistoricoPublicacaoIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/importacao/': {
      id: '/_authenticated/importacao/'
      path: '/importacao'
      fullPath: '/importacao/'
      preLoaderRoute: typeof AuthenticatedImportacaoIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/relatorio-transacoes/': {
      id: '/_authenticated/relatorio-transacoes/'
      path: '/relatorio-transacoes'
      fullPath: '/relatorio-transacoes/'
      preLoaderRoute: typeof AuthenticatedRelatorioTransacoesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/unidades/': {
      id: '/_authenticated/unidades/'
      path: '/unidades'
      fullPath: '/unidades/'
      preLoaderRoute: typeof AuthenticatedUnidadesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/usuarios/': {
      id: '/_authenticated/usuarios/'
      path: '/usuarios'
      fullPath: '/usuarios/'
      preLoaderRoute: typeof AuthenticatedUsuariosIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/vinculos-mapa/': {
      id: '/_authenticated/vinculos-mapa/'
      path: '/vinculos-mapa'
      fullPath: '/vinculos-mapa/'
      preLoaderRoute: typeof AuthenticatedVinculosMapaIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/empresas/': {
      id: '/_authenticated/admin/empresas/'
      path: '/admin/empresas'
      fullPath: '/admin/empresas/'
      preLoaderRoute: typeof AuthenticatedAdminEmpresasIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/estabelecimentos/': {
      id: '/_authenticated/admin/estabelecimentos/'
      path: '/admin/estabelecimentos'
      fullPath: '/admin/estabelecimentos/'
      preLoaderRoute: typeof AuthenticatedAdminEstabelecimentosIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/sincronizacao-pga/': {
      id: '/_authenticated/admin/sincronizacao-pga/'
      path: '/admin/sincronizacao-pga'
      fullPath: '/admin/sincronizacao-pga/'
      preLoaderRoute: typeof AuthenticatedAdminSincronizacaoPgaIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/unidades/': {
      id: '/_authenticated/admin/unidades/'
      path: '/admin/unidades'
      fullPath: '/admin/unidades/'
      preLoaderRoute: typeof AuthenticatedAdminUnidadesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/usuarios/': {
      id: '/_authenticated/admin/usuarios/'
      path: '/admin/usuarios'
      fullPath: '/admin/usuarios/'
      preLoaderRoute: typeof AuthenticatedAdminUsuariosIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/relatorio-transacoes/$tipo/$ano/': {
      id: '/_authenticated/relatorio-transacoes/$tipo/$ano/'
      path: '/relatorio-transacoes/$tipo/$ano'
      fullPath: '/relatorio-transacoes/$tipo/$ano/'
      preLoaderRoute: typeof AuthenticatedRelatorioTransacoesTipoAnoIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/relatorio-transacoes/$tipo/$ano/$mes': {
      id: '/_authenticated/relatorio-transacoes/$tipo/$ano/$mes'
      path: '/relatorio-transacoes/$tipo/$ano/$mes'
      fullPath: '/relatorio-transacoes/$tipo/$ano/$mes'
      preLoaderRoute: typeof AuthenticatedRelatorioTransacoesTipoAnoMesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedAtualizarTransacoesIndexRoute: typeof AuthenticatedAtualizarTransacoesIndexRoute
  AuthenticatedCadastrosCodigoMapaIndexRoute: typeof AuthenticatedCadastrosCodigoMapaIndexRoute
  AuthenticatedConversaoUnidadeMedidaIndexRoute: typeof AuthenticatedConversaoUnidadeMedidaIndexRoute
  AuthenticatedDashboardIndexRoute: typeof AuthenticatedDashboardIndexRoute
  AuthenticatedEstabelecimentosIndexRoute: typeof AuthenticatedEstabelecimentosIndexRoute
  AuthenticatedHistoricoPublicacaoIndexRoute: typeof AuthenticatedHistoricoPublicacaoIndexRoute
  AuthenticatedImportacaoIndexRoute: typeof AuthenticatedImportacaoIndexRoute
  AuthenticatedRelatorioTransacoesIndexRoute: typeof AuthenticatedRelatorioTransacoesIndexRoute
  AuthenticatedUnidadesIndexRoute: typeof AuthenticatedUnidadesIndexRoute
  AuthenticatedUsuariosIndexRoute: typeof AuthenticatedUsuariosIndexRoute
  AuthenticatedVinculosMapaIndexRoute: typeof AuthenticatedVinculosMapaIndexRoute
  AuthenticatedAdminEmpresasIndexRoute: typeof AuthenticatedAdminEmpresasIndexRoute
  AuthenticatedAdminEstabelecimentosIndexRoute: typeof AuthenticatedAdminEstabelecimentosIndexRoute
  AuthenticatedAdminSincronizacaoPgaIndexRoute: typeof AuthenticatedAdminSincronizacaoPgaIndexRoute
  AuthenticatedAdminUnidadesIndexRoute: typeof AuthenticatedAdminUnidadesIndexRoute
  AuthenticatedAdminUsuariosIndexRoute: typeof AuthenticatedAdminUsuariosIndexRoute
  AuthenticatedRelatorioTransacoesTipoAnoMesRoute: typeof AuthenticatedRelatorioTransacoesTipoAnoMesRoute
  AuthenticatedRelatorioTransacoesTipoAnoIndexRoute: typeof AuthenticatedRelatorioTransacoesTipoAnoIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedAtualizarTransacoesIndexRoute:
    AuthenticatedAtualizarTransacoesIndexRoute,
  AuthenticatedCadastrosCodigoMapaIndexRoute:
    AuthenticatedCadastrosCodigoMapaIndexRoute,
  AuthenticatedConversaoUnidadeMedidaIndexRoute:
    AuthenticatedConversaoUnidadeMedidaIndexRoute,
  AuthenticatedDashboardIndexRoute: AuthenticatedDashboardIndexRoute,
  AuthenticatedEstabelecimentosIndexRoute:
    AuthenticatedEstabelecimentosIndexRoute,
  AuthenticatedHistoricoPublicacaoIndexRoute:
    AuthenticatedHistoricoPublicacaoIndexRoute,
  AuthenticatedImportacaoIndexRoute: AuthenticatedImportacaoIndexRoute,
  AuthenticatedRelatorioTransacoesIndexRoute:
    AuthenticatedRelatorioTransacoesIndexRoute,
  AuthenticatedUnidadesIndexRoute: AuthenticatedUnidadesIndexRoute,
  AuthenticatedUsuariosIndexRoute: AuthenticatedUsuariosIndexRoute,
  AuthenticatedVinculosMapaIndexRoute: AuthenticatedVinculosMapaIndexRoute,
  AuthenticatedAdminEmpresasIndexRoute: AuthenticatedAdminEmpresasIndexRoute,
  AuthenticatedAdminEstabelecimentosIndexRoute:
    AuthenticatedAdminEstabelecimentosIndexRoute,
  AuthenticatedAdminSincronizacaoPgaIndexRoute:
    AuthenticatedAdminSincronizacaoPgaIndexRoute,
  AuthenticatedAdminUnidadesIndexRoute: AuthenticatedAdminUnidadesIndexRoute,
  AuthenticatedAdminUsuariosIndexRoute: AuthenticatedAdminUsuariosIndexRoute,
  AuthenticatedRelatorioTransacoesTipoAnoMesRoute:
    AuthenticatedRelatorioTransacoesTipoAnoMesRoute,
  AuthenticatedRelatorioTransacoesTipoAnoIndexRoute:
    AuthenticatedRelatorioTransacoesTipoAnoIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  SplatRoute: SplatRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginIndexRoute: LoginIndexRoute,
  ProdutosNaoVinculadosIndexRoute: ProdutosNaoVinculadosIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
